import React from 'react'
import { Trans } from 'gatsby-plugin-react-i18next'
import { GatsbyImage } from 'gatsby-plugin-image'
import { graphql, useStaticQuery } from 'gatsby'

import {
  MatrixContainer,
  Section,
  Row,
  Cell,
  CheckCell,
  HeaderCell,
  Title,
  Subheader,
  Checkmark,
  FeatureName,
  FeatureDetail,
  Table,
  HeaderCellText,
} from './styles'
import { COMPETITOR_COMPARISON } from './constants'

const CalendarMatrix = () => {
  const { green, red, gray } = useStaticQuery(graphql`
    query CalendarMatrixQuery {
      green: file(relativePath: { eq: "calendar/checkbox-green.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      red: file(relativePath: { eq: "calendar/checkbox-red.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      gray: file(relativePath: { eq: "calendar/checkbox-gray.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  return (
    <Section>
      <MatrixContainer>
        <Subheader>The choice is easy</Subheader>
        <Table>
          <thead>
            <Row last>
              <HeaderCell />
              <HeaderCellText>
                <Title>Skylight Calendar</Title>
              </HeaderCellText>
              <HeaderCellText>
                <Title>Others</Title>
              </HeaderCellText>
            </Row>
          </thead>
          <tbody>
            {COMPETITOR_COMPARISON.map((feature, index) => (
              <Row key={index} white={index % 2 === 0}>
                <Cell>
                  <FeatureName>
                    <Trans>{feature.text}</Trans>
                  </FeatureName>
                  {feature.detail && (
                    <FeatureDetail>
                      <Trans>{feature.detail}</Trans>
                    </FeatureDetail>
                  )}
                </Cell>
                <CheckCell blue>
                  <Checkmark>
                    <GatsbyImage
                      image={green.childImageSharp.gatsbyImageData}
                      alt="Green check mark indicating feature is included"
                    />
                  </Checkmark>
                </CheckCell>
                <CheckCell check borderRadius>
                  <Checkmark>
                    <GatsbyImage
                      image={
                        feature.them
                          ? gray.childImageSharp.gatsbyImageData
                          : red.childImageSharp.gatsbyImageData
                      }
                      alt={`${
                        feature.them
                          ? 'Gray check mark indicating feature is included'
                          : 'Red check mark indicating feature is not included'
                      }`}
                    />
                  </Checkmark>
                </CheckCell>
              </Row>
            ))}
          </tbody>
        </Table>
      </MatrixContainer>
    </Section>
  )
}

export default CalendarMatrix
